
import brand from './brand.js';


export default [
    ...brand,
    {
        path: '/qualityTraceability',
        name: 'qualityTraceability',
        component: function (resolve) {
            require(['@/pages/qualityTraceability'],resolve)
        }
    },
    {
        path: '/traceProduct',
        name: 'traceProduct',
        component: function (resolve) {
            require(['@/pages/qualityTraceability/traceProduct'],resolve)
        }
    },
    {
        path: '/batchTrace',
        name: 'batchTrace',
        component: function (resolve) {
            require(['@/pages/qualityTraceability/batchTrace'],resolve)
        }
    },
    {
        path: '/batchList',
        name: 'batchList',
        component: function (resolve) {
            require(['@/pages/qualityTraceability/batchList'],resolve)
        }
    },
    {
        path: '/batchDetail',
        name: 'batchDetail',
        component: function (resolve) {
            require(['@/pages/qualityTraceability/batchDetail'],resolve)
        }
    },
    {
        path: '/createBatch',
        name: 'createBatch',
        component: function (resolve) {
            require(['@/pages/qualityTraceability/createBatch'],resolve)
        }
    },
    {
        path: '/survey',
        name: 'survey',
        component: function (resolve) {
            require(['@/pages/survey'],resolve)
        }
    },
    {
        path: '/marketOperation',
        name: 'marketOperation',
        component: function (resolve) {
            require(['@/pages/marketOperation'],resolve)
        }
    },
    {
        path: '/brandConsumer',
        name: 'brandConsumer',
        component: function (resolve) {
            require(['@/pages/marketOperation/brandConsumer'],resolve)
        }
    },
    {
        path: '/brandMarket',
        name: 'brandMarket',
        component: function (resolve) {
            require(['@/pages/marketOperation/brandMarket'],resolve)
        }
    },
    {
        path: '/brandTrend',
        name: 'brandTrend',
        component: function (resolve) {
            require(['@/pages/marketOperation/brandTrend'],resolve)
        }
    },
    {
        path: '/orderMana',
        name: 'orderMana',
        component: function (resolve) {
            require(['@/pages/marketOperation/orderMana'],resolve)
        }
    },
    {
        path: '/editeMarket',
        name: 'editeMarket',
        component: function (resolve) {
            require(['@/pages/marketOperation/editeMarket/index'],resolve)
        }
    },
    {
        path: '/complaintFeedback',
        name: 'complaintFeedback',
        component: function (resolve) {
            require(['@/pages/complaintFeedback'],resolve)
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/govLayout/layoutChildren.js